import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { CategorySingleSelectorData, CategorySingleSelectorDialog } from "./category-single-select.dialog";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { combineLatest, lastValueFrom, take, takeUntil } from "rxjs";
import { listingsFeature } from "../../../store/listings.store";
import { Base } from "../../wrapper/base-wrapper.component";
import { categoriesFeature } from "../../../store/category.store";
import { CategorySelected } from "./category-selector";
import { Logger } from "../../../helper/logger";
import { ListingPublic } from "../../../../../globalTypes/listings.types";

const log = new Logger('CategorySingleSelector');

@Component({
  selector: 'msh-category-single-selector',
  template: `
  <button
    mat-stroked-button
    (click)="onClickSelectButton()"
    
  >{{ !selectedCategory ? 'Select Category' : 'Category: '+selectedCategory }}
  </button>
  `,
  styles: ``,
  imports: [MatButtonModule]

})
export class CategorySingleSelectorComponent extends Base<CategorySingleSelectorComponent> {
  @Output() onSelectCategory: EventEmitter<CategorySelected> = new EventEmitter;
  selectedCategory = '';
  listing!: ListingPublic;


  constructor(
    private dialog: MatDialog,
    private store: Store,
  ){
    super();
    combineLatest([
      this.store.select(listingsFeature.selectListing),
      this.store.select(categoriesFeature.selectEntities),
    ]).pipe(takeUntil(this.$destroy)).subscribe(([listing, cats]) => {
      this.listing = listing as ListingPublic;
      const catId = listing && listing.categoryId;;
      this.selectedCategory = catId && cats[catId] ? cats[catId].name || '' : '';
      log.log({selectedCategory: this.selectedCategory, cats, listing})
    })
  }

  async onClickSelectButton(){
    // [ ] - TEST THIS add the category from the listing
    const data: CategorySingleSelectorData = {category: undefined}
    // log.log({data: data});
    
    const dialog = this.dialog.open(CategorySingleSelectorDialog, {data});
    const results = await lastValueFrom(dialog.afterClosed().pipe(take(1)))
    this.selectedCategory = results?.name || '';
    this.onSelectCategory.emit(results);
  }
}